import Layout from "../components/layout/Layout";

export default function Error404() {
    return (
        <Layout headerStyle={1} footerStyle={1} breadcrumbTitle="404 Not Found">
            <div className="error-full-image-wrapper">
                <img
                    src="/images/background.png"
                    alt="404 Not Found"
                    className="error-full-image"
                />
                <div className="error-text-center">
                    <div className="text-center">
                        <h1 className="error-code" style={{ color: "#fff" }}>404</h1>
                        <h2 className="error-message" style={{ color: "#fff" }}>Page Not Found</h2>
                        <p style={{ color: "#fff", fontSize: '18px' }}>
                            Sorry, the page you’re looking for doesn’t exist or has been moved.
                        </p>
                    </div>
                    <div className="text-center mt-4">
                        <a href="/home" className="btn-contact">Back to home page</a>
                    </div>
                </div>
            </div>
        </Layout>

    );
}
